// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Ir0t","content":"RecentSearches_content__1MKdC"};